/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.getSpinToWinPrizes.internal

import features.getSpinToWinPrizes.models.SpinToWinPrizesModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class GetSpinToWinPrizesRequest : NetworkRequest() {

    suspend fun getSpinToWinPrizes(
        overrideHeaders: Map<String, String>? = null,
        businessId: String
    ): IOResult<SpinToWinPrizesModel> {
        return safeNetworkCall {
            get(
                endpoint = GetSpinToWinPrizesEndpoint.replaceInPath(
                    PathParameter("businessId", businessId),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
